module.exports = __webpack_public_path__ + "img/2.b3ce8160.png";